import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isStaticPublicPath, trackPublicPageview } from "../utils/trackPageview";

function TrackPageview() {
  const location = useLocation();

  useEffect(() => {
    if (!isStaticPublicPath(location.pathname)) return undefined;
    if (document.prerendering) {
      const onReady = () => trackPublicPageview({ path: location.pathname });
      document.addEventListener("prerenderingchange", onReady, { once: true });
      return () => document.removeEventListener("prerenderingchange", onReady);
    }
    trackPublicPageview({ path: location.pathname });
    return undefined;
  }, [location.pathname]);

  return null;
}

export default TrackPageview;
